import React, { memo } from "react";
import { Handle, Position, NodeProps } from "@xyflow/react";
import { Clock, Cpu, GripVertical, CheckCircle, AlertCircle } from "./Icons";
import { TaskType, TaskDefinition } from "../types";

interface TaskNodeData extends Record<string, unknown> {
  label: string;
  type: TaskType;
  durationMinutes: number;
  onLabelChange?: (newLabel: string) => void;
  isConnectable: boolean;
}

const TaskNode = ({ data, isConnectable, selected }: NodeProps<any>) => {
  const { label, type, durationMinutes, onLabelChange } = data as TaskNodeData;

  return (
    <div
      className={`px-4 py-3 rounded-xl shadow-sm border transaction-all duration-200 w-[240px]
      ${
        selected
          ? "bg-white dark:bg-slate-800 border-indigo-500 ring-2 ring-indigo-500/20 shadow-md"
          : "bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700"
      }
    `}
    >
      <Handle
        type="target"
        position={Position.Left}
        isConnectable={isConnectable}
        className="!w-2 !h-2 !bg-slate-400 dark:!bg-slate-500 !-left-1.5"
      />

      <div className="flex items-start gap-3">
        {/* Drag Handle Icon - purely visual since dragging entire node works */}
        <div className="mt-1 text-slate-300 dark:text-slate-600">
          <GripVertical size={14} />
        </div>

        <div className="flex-1 min-w-0">
          <input
            className="w-full bg-transparent font-bold text-sm text-slate-800 dark:text-slate-100 outline-none placeholder-slate-400"
            value={label}
            onChange={(e) => onLabelChange?.(e.target.value)}
            placeholder="Task Name"
          />
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Right}
        isConnectable={isConnectable}
        className="!w-2 !h-2 !bg-slate-400 dark:!bg-slate-500 !-right-1.5"
      />
    </div>
  );
};

export default memo(TaskNode);
